import React from "react";
import { Typography, Box, Grid, Paper } from "@material-ui/core";

import BorderLinearProgress from "../BorderLinearProgress";

import stringUtils from "../../utils/stringUtils";

import useStyles from "./style";

const CardDashboardConsumo = (props) => {
    const classes = useStyles();

    const percentual_mes = props.dados.valor_mes > 0.0 ? 100 : 0;
    const percentual_semana =
        props.dados.valor_mes > 0.0
            ? Math.ceil(
                  (props.dados.valor_semana / props.dados.valor_mes) * 100
              )
            : 0;
    const percentual_hoje =
        props.dados.valor_mes > 0.0
            ? Math.ceil((props.dados.valor_hoje / props.dados.valor_mes) * 100)
            : 0;

    return (
        <Paper className={classes.cardPaper}>
            <Grid container direction="row" spacing={4}>
                <Grid item xs={12}>
                    <Box color="primaryDark.main">
                        <Typography variant="h6">
                            <b>Consumo</b>
                        </Typography>
                        <Typography variant="body2">
                            Mensal, semanal e diário
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item md={9} xs={8}>
                            <Box height="1.6rem">
                                <BorderLinearProgress
                                    variant="determinate"
                                    value={percentual_mes}
                                    colorbar="#17325C"
                                    bgcolor="#17325C20"
                                />
                                <span className={classes.barText}>Mês</span>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs={4}>
                            <Box fontSize={13} fontWeight="bold">
                                {stringUtils.formatBRL(props.dados.valor_mes)}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item md={9} xs={8}>
                            <Box height="1.6rem">
                                <BorderLinearProgress
                                    variant="determinate"
                                    value={percentual_semana}
                                    colorbar="#6CA76B"
                                    bgcolor="#6CA76B20"
                                />
                                <span className={classes.barText}>Semana</span>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs={4}>
                            <Box fontSize={13} fontWeight="bold">
                                {stringUtils.formatBRL(
                                    props.dados.valor_semana
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item md={9} xs={8}>
                            <Box height="1.6rem">
                                <BorderLinearProgress
                                    variant="determinate"
                                    value={percentual_hoje}
                                    colorbar="#000000"
                                    bgcolor="#00000020"
                                />
                                <span className={classes.barText}>Hoje</span>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs={4}>
                            <Box fontSize={13} fontWeight="bold">
                                {stringUtils.formatBRL(props.dados.valor_hoje)}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default CardDashboardConsumo;
